var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSenderDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 24,
    height: 24,
    viewBox: "0 0 34 34",
    fill: "#ccc",
    className: "cly__qxcdzn-0 dMIsNQ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "#ccc",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-email-send-(3)",
    transform: "translate(14.000000, 18.000000) rotate(-315.000000) translate(-14.000000, -18.000000) translate(2.000000, 6.000000)",
    fill: "#ccc",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,0 C22.9040261,0.000658358195 22.8086469,0.0151297178 22.716797,0.0429688 C22.6897605,0.0503069172 22.6630442,0.0587779232 22.636719,0.0683594 L0.6503906,7.060547 L0.6503906,7.064453 C0.259758564,7.21021976 0.000562408886,7.58305754 0,8 C0.000740822587,8.34922483 0.183611423,8.67276525 0.4824219,8.853516 L7.164062,14.154297 L20.373047,3.6269531 L9.845703,16.835938 L15.142578,23.513672 C15.3230843,23.8151719 15.6485961,24 16,24 C16.4169426,23.9994375 16.7897804,23.7402412 16.935547,23.349609 L16.939453,23.349609 L23.9375,1.34375 C23.9446508,1.32377995 23.9511645,1.30358744 23.957031,1.2832031 C23.9848702,1.1913532 23.9993416,1.0959739 24,1 C24,0.44771525 23.5522847,0 23,0 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenderDefault);
export default __webpack_public_path__ + "static/media/sender_default.e5cc7090d82d1cc547e5970d35638d28.svg";
export { ForwardRef as ReactComponent };